
import { storageCls, Key, expire, Data, Result } from './type';
import { Dictionaries } from "./enum";
import { getDailyPaper } from '@/api';
// import axios from 'axios';


const countTime: MethodDecorator = (target, propertyKey, descriptor) => {
    // descriptor.value("111")
    // console.log(target, propertyKey, descriptor);

}

const initData = (url: string): MethodDecorator => {
    return function (target: any, propertyKey: string | symbol, descriptor: PropertyDescriptor) {

        const originalMethod = descriptor.value;
        descriptor.value = async function (...args: any[]) {
            const result = await getDailyPaper();
            // console.log(result);
            target.pwd = result;
            originalMethod.apply(this, args);
        };
    };
};



export class Storage implements storageCls {
    private constructor() { }
    private static _instance: Storage;
    pwd: string;
    account: string;
    static getInstance() {
        if (!Storage._instance) {
            Storage._instance = new Storage();
        }
        return Storage._instance;
    }

    @countTime
    set<T>(key: Key, value: T, expire: expire = Dictionaries.permanent) {
        // console.log(arguments)
        const data = {
            value: value,
            [Dictionaries.expire]: expire
        }
        localStorage.setItem(key, JSON.stringify(data))
    }
    // @initData("")
    get<T = any>(key: Key): Result<T | null> {
        // console.log("1111")
        // console.log(key, 111111)
        let value = localStorage.getItem(key);
        if (value) {
            const obj = JSON.parse(value);
            const now = new Date().getTime();
            // alert(obj[Dictionaries.expire])
            // alert(now)
            if (typeof obj[Dictionaries.expire] == 'number' && obj[Dictionaries.expire] < now) {
                this.remove(key)
                return {
                    message: `您的${key}已过期`,
                    value: null
                };
            } else {
                return {
                    message: `获取成功！`,
                    value: obj.value
                };
            }
        }
    }
    remove(key: Key) {
        localStorage.removeItem(key);
    }
}
